type Chat = {
  id: string;
  workflowId: string | null;
  lastActiveAt: number;
};

// Rows match the chat list, so a workflow is offered only when every chat behind it can go.
export function tidyUpRows<T extends Chat>(
  chats: readonly T[],
  tidyable: (chat: T) => boolean
): { chat: T; chatIds: string[] }[] {
  const groups = Map.groupBy(chats, (chat) => chat.workflowId ?? chat.id);
  return [...groups.values()].flatMap((group) => {
    if (!group.every(tidyable)) return [];
    const shown = group.toSorted((a, b) => b.lastActiveAt - a.lastActiveAt)[0]!;
    return [{ chat: shown, chatIds: group.map((chat) => chat.id) }];
  });
}
